
const videos = document.querySelectorAll('.video');

if (videos.length) {
    // add to iframe api only once
    let addScript = true;
    const url = 'https://www.youtube.com/iframe_api';
    const scripts = document.getElementsByTagName('script');
    for (let i = scripts.length; i--;) {
        if (scripts[i].src === url) {
            addScript = false;
        }
    }

    if (addScript) {
        // 2. This code loads the IFrame Player API code asynchronously.
        const tag = document.createElement('script');

        tag.src = url;

        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    // Create an array of all video's on the page
    const videoList = [];

    [...videos].forEach((video) => {
        const videoId = video.getAttribute('data-video-id');
        if (videoId !== '') {
            videoList.push({
                id: `player-${ videoId }`,
                height: '100%',
                width: '100%',
                videoId: `${ videoId }`,
                playerVars: {
                    'playsinline': 1,
                },
                events: {
                    'onReady': (event) => {
                        onPlayerReady(event, videoId);
                    },
                },
            });
        }
    });

    // Create players based on the array above
    window.onYouTubeIframeAPIReady = () => {
        for (let i = 0; i < videoList.length; i++) {
            createPlayer(videoList[i]);
        }
    };
}

function createPlayer(videoInfo) {
    return new window.YT.Player(videoInfo.id, {
        height: videoInfo.height,
        width: videoInfo.width,
        videoId: videoInfo.videoId,
        playerVars: videoInfo.playerVars,
        events: videoInfo.events,
    });
}

// Play the video when clicking on the play icon
function onPlayerReady(event, videoId) {
    const playIcon = document.getElementById(`play-circle-${ videoId }`);

    playIcon.addEventListener('click', () => {
        const parentElement = playIcon.parentElement;
        const videoOverlay = parentElement.querySelector('.video-overlay');
        if (videoOverlay) {
            videoOverlay.style.display = 'none';
        }
        if (playIcon) {
            playIcon.style.display = 'none';
        }
        event.target.playVideo();
    });
}
